import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ISection } from 'typings/doenkids/doenkids';
import { ISectionState, SectionStore } from './section.store';

@Injectable({ providedIn: 'root' })
export class SectionQuery extends QueryEntity<ISectionState, ISection> {
  constructor(protected store: SectionStore) {
    super(store);
  }

  get getMetadata() {
    return this.select((value) => ({
      total: value.total,
      skip: value.skip,
      limit: value.limit,
    }));
  }
}
